import { FaLink } from "react-icons/fa";
import { toast } from "react-hot-toast";
import FacebookIcon from "../../ui/svg/FacebookIcon";
import TwitterIcon from "../../ui/svg/TwitterIcon";
import LinkedInIcon from "../../ui/svg/LinkedInIcon";

const SocialIcons = ({
  isOpen,
  shareableLink,
  copyLink,
  bgColor = "bg-white",
  iconGradientStart = "#004d00",
  iconGradientEnd = "#00e600",
}) => {
  const encodedUrl = encodeURIComponent(shareableLink);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(copyLink).then(() => {
      toast.dismiss();
      toast.success("Link copied to clipboard!");
    });
  };

  return (
    <div
      className={`absolute right-16 top-0 h-12 xxs:right-14 ${bgColor} rounded-full flex items-center gap-3 px-4 transition-all duration-500 ease-in-out ${
        isOpen ? "opacity-100 right-16" : "opacity-0 right-[-100px]"
      }`}
      style={{ boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)" }}
    >
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        className="cursor-pointer hover:scale-110 transition-all"
        onClick={(e) => e.stopPropagation()}
      >
        <FacebookIcon
          startColor={iconGradientStart}
          endColor={iconGradientEnd}
          size="w-5 h-5"
        />
      </a>

      <a
        href={`https://twitter.com/intent/tweet?url=${encodedUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        className="cursor-pointer hover:scale-110 transition-all"
        onClick={(e) => e.stopPropagation()}
      >
        <TwitterIcon
          startColor={iconGradientStart}
          endColor={iconGradientEnd}
          size="w-5 h-5"
        />
      </a>

      <a
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`}
        target="_blank"
        rel="noopener noreferrer"
        className="cursor-pointer hover:scale-110 transition-all"
        onClick={(e) => e.stopPropagation()}
      >
        <LinkedInIcon
          startColor={iconGradientStart}
          endColor={iconGradientEnd}
          size="w-5 h-5"
        />
      </a>

      <button
        onClick={(e) => {
          e.stopPropagation();
          copyToClipboard();
        }}
        className="cursor-pointer hover:scale-110 transition-all"
      >
        <FaLink className="w-4 h-4 text-gray-400" />
      </button>
    </div>
  );
};

export default SocialIcons;